'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _STYLE_COMMAND_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STYLE_TYPES = exports.STYLE_TYPES = {
    INLINE: 'INLINE',
    BLOCK: 'BLOCK'
};

var STYLE_COMMANDS = exports.STYLE_COMMANDS = {
    BOLD: 'BOLD',
    ITALIC: 'ITALIC',
    HEADING: 'header-two',
    BLOCKQUOTE: 'blockquote',
    CODE: 'code-block',
    LIST: 'unordered-list-item',
    ORDERED_LIST: 'ordered-list-item',
    CHECKLIST: 'checklist',
    UNSTYLED: 'unstyled',
    HEADING_PREFIX: 'header'
};

var STYLE_COMMAND_TYPES = exports.STYLE_COMMAND_TYPES = (_STYLE_COMMAND_TYPES = {}, _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.BOLD, STYLE_TYPES.INLINE), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.ITALIC, STYLE_TYPES.INLINE), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.HEADING, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.BLOCKQUOTE, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.CODE, STYLE_TYPES.INLINE), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.LIST, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.ORDERED_LIST, STYLE_TYPES.BLOCK), _defineProperty(_STYLE_COMMAND_TYPES, STYLE_COMMANDS.CHECKLIST, STYLE_TYPES.BLOCK), _STYLE_COMMAND_TYPES);

var TOOLS = {
    HEADING: { name: 'Heading', textCommand: STYLE_COMMANDS.HEADING, iconName: 'toolbar-h1' },
    BOLD: { name: 'Bold', textCommand: STYLE_COMMANDS.BOLD, iconName: 'toolbar-bold' },
    ITALIC: { name: 'Italic', textCommand: STYLE_COMMANDS.ITALIC, iconName: 'toolbar-italic' },
    LIST: { name: 'Bullet', textCommand: STYLE_COMMANDS.LIST, iconName: 'toolbar-list' },
    ORDERED_LIST: { name: 'Numbered list', textCommand: STYLE_COMMANDS.ORDERED_LIST, iconName: 'toolbar-numlist' },
    CHECKLIST: { name: 'Checklist', textCommand: STYLE_COMMANDS.CHECKLIST, iconName: 'toolbar-checklist' },
    QUOTE: { name: 'Quote', textCommand: STYLE_COMMANDS.BLOCKQUOTE, iconName: 'toolbar-quote' }
};

var INLINE_STYLE_TOOLS = exports.INLINE_STYLE_TOOLS = [TOOLS.BOLD, TOOLS.ITALIC];

var RICH_STYLE_TOOLS = exports.RICH_STYLE_TOOLS = [TOOLS.HEADING, TOOLS.BOLD, TOOLS.ITALIC, TOOLS.LIST, TOOLS.ORDERED_LIST, TOOLS.CHECKLIST, TOOLS.QUOTE];


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/richText/richTextConstants.js
// module id = 166
// module chunks = 0